export function internalChatActions(action, data) {
    return {
      type: action,
      payload: data
    }
}